import { render } from "./client.vue?vue&type=template&id=6309456a&ts=true"
import script from "./client.vue?vue&type=script&lang=ts"
export * from "./client.vue?vue&type=script&lang=ts"

import "./client.vue?vue&type=style&index=0&id=6309456a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__